import apiService from "./apiService";

const requestPharmacistList = (query) => {
  let queryParams = {
    q: query?.pharmacist ?? '',
    item_per_page:  10,
    page: query?.page ?? 1,
  }
 
  return apiService.get(URIS.pharmacists, {
    params: queryParams,
  })
}

const requestNewPharmacistCreation = (pharmacistPayload) => {
  return apiService.post(URIS.pharmacists,pharmacistPayload)
}


export {requestPharmacistList, requestNewPharmacistCreation}

const URIS_D = (url, param1) => {
  return {
    deletePharmacist: `/admin/promotional-events/${param1}`,
  }[url]
}

const URIS = {
  pharmacists: '/pharmacy/pharmacists',
}
